<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    یادداشت های من
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>


            <div class="card card-style mb-2 p-3 overflow-visible z-index1000">
                <div class="d-flex justify-content-start">
                    <div class="w-100 search-box search-color bg-magenta1-light rounded-m position-relative">
                        <i class="fa fa-search pr-3"></i>
                        <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
                    </div>
                </div>
            </div>

            <div class="card card-style mb-2" @click.prevent="openDetails(task.noteId)" v-for="task in TaskNoteList" :key="task.noteId">
                <div class="list-group list-custom-small list-icon-0" style="border-radius: 15px !important; border-right: 15px solid" :style="{ 'border-color': task.color }">
                    <div class="list-group-div p-2" >
                        <div>
                            <i class="fa fa-calendar text-warning"></i>
                            <span class="text-muted d-inline-block text-left ltr">{{task.createDateTime}}</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                <i class="fa fa-check color-red1-dark"></i>
                                <span class="font-weight-bold">{{task.title}}</span>
                            </div>
                            <span @click.stop="showMenu(task)" width="60px"><i class="fa fa-ellipsis-v font-14"></i></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card card-style" v-if="Loading==false && NoMoreData==false && TaskNoteList.length>0 && TaskNoteList.length%20==0">
                <div class="content">
                    <div class="d-flex justify-content-center w-100 py-2">
                        <button class="btn btn-outline-info" @click="getNextPageForTaskNoteList">نمایش بیشتر</button>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="Loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100 py-5">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="TaskNoteList.length==0 && Loading==false">
                <div class="content">
                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                    <p class="text-center py-3">یادداشتی یافت نشد.</p>
                </div>
            </div>

        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
                <router-link to="/CreateTaskNote" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="pageLoading==true" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'EditTaskNote', params: { noteId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="Share" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-share-alt text-warning float-right font-14"></i>اشتراک گذاری</span><i class="fa fa-angle-left"></i></button>
                    <button @click="copyTaskNote" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-copy color-magenta2-dark float-right font-14"></i>کپی</span><i class="fa fa-angle-left"></i></button>
                    <button @click="AddPin" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-thumbtack color-blue2-light float-right font-14"></i>نشان کردن</span><i class="fa fa-angle-left"></i></button>

                    <button @click="deleteTaskNote" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
        <!--<div id="taskNoteHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>

                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-TaskNote.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-TaskNote.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->

    </div>



</template>

<script>
    import VueSimpleAlert from "vue3-simple-alert";
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedWorkId: 0,
                selectedTitle: 0,
                pageLoaded: false,
                pageLoading: false
            };
        },
        computed: {
            TaskNoteList() {
                return this.$store.getters.GetTaskNoteList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetTaskNoteNoMoreData;
            },
            UpdateTaskNoteList() {
                return this.$store.getters.GetUpdateTaskNoteList;
            },
        },

        created() {
            console.log(this.NoMoreData);

            this.$store.dispatch("GetTaskNoteListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {
            showAddButton() {
                this.pageLoaded = true;

            },
            showMenu(n) {
                this.selectedWorkId = n.noteId;
                this.selectedTitle = n.title;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetTaskNoteListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            copyTaskNote() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm("آیا مایل به ثبت یک کپی از این یادداشت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.pageLoading = true;
                    setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)

                    this.$http.get("TaskNote/CopyTaskNote?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data;
                            if (!isNaN(res)) {
                                this.$router.push({ name: 'EditTaskNote', params: { noteId: res } });
                            }
                            else {
                                this.showErrorMessage(res);
                            }
                            this.pageLoading = false;

                        });
                });
            },
            Share() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm("آیا مایل به اشتراک گذاری این یادداشت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.pageLoading = true;
                    setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)
                    var data = {
                        shareDoc: 1,
                        id: this.selectedWorkId
                    };
                    this.$http.post("TaskNote/ShareDoc", data)
                        .then(data => {
                            this.pageLoading = false;
                            var res = data.data;
                            if (res.isSuccess) {
                                window.open(res.obj, '_blank');
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });

                });
            },
            deleteTaskNote() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این یادداشت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("TaskNote/DeleteTaskNote?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res === "1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.page = 0;
                                this.getNextPageForTaskNoteList();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            openDetails(noteId) {
                this.$router.push({ name: 'EditTaskNote', params: { noteId: noteId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForTaskNoteList() {

                this.page++;
                console.log(this.page);
                this.$store.dispatch("GetTaskNoteListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            AddPin() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به نشان کردن این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {

                    this.$store.dispatch("AddPin", {
                        baseDocId: 28,
                        docId: this.selectedWorkId,
                        description: this.selectedTitle
                    });
                });

            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        activated() {
            console.log("mounted");
            this.showAddButton();
            if (this.UpdateTaskNoteList == true) {
                this.page = 0;
                this.getNextPageForTaskNoteList();
            }

        },
        mounted() {
            this.showAddButton();
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>
